/**
 * Provider nesting order (outermost → innermost):
 *   ClerkProvider    — Clerk session and sign-in components
 *   ClerkAuthBridge  — wires the token getter, provides the legacy auth value
 *   ThreadProvider   — reads auth session, fetches threads
 */
import { ClerkProvider } from "@clerk/react"
import { ClerkAuthBridge } from "./ClerkAuthBridge"
import { ThreadProvider } from "./ThreadProvider"
import { clerkAppearance } from "@/lib/clerkAppearance"
import { env } from "@/lib/env"
import { router } from "@/shell/router"
import type { ReactNode } from "react"

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ClerkProvider
      publishableKey={env.VITE_CLERK_PUBLISHABLE_KEY}
      routerPush={(to) => router.navigate(to)}
      routerReplace={(to) => router.navigate(to, { replace: true })}
      appearance={clerkAppearance}
      signInUrl="/auth/login"
      signUpUrl="/auth/signup"
      afterSignOutUrl="/"
    >
      <ClerkAuthBridge>
        <ThreadProvider>{children}</ThreadProvider>
      </ClerkAuthBridge>
    </ClerkProvider>
  )
}
